import React from 'react';
import styled from 'styled-components';
import { Button, Section } from '../../../common';
import AppStore from '../../../../assets/AppStore';
import Technology from './components/Technology';
import CompanyTitle from './components/CompanyTitle';
import RatioImage from '../../../common/RatioImage';

export default class Header extends React.Component {
  render() {
    const { product, company } = this.props;
    return (
      <SectionWrapper>
        <RatioImage src={product.productImage} />
        <HeaderContentWrapper>
          <StyledCompanyTitle {...company} />
          <div>
            <Title>{product.name}</Title>
            <ProductShortDescription>{product.description}</ProductShortDescription>
          </div>
          {product.links.websiteUrl && <GoToWebsiteButton blue>Go to website</GoToWebsiteButton>}
          <StoreList>{product.links.appStoreUrl && <StyledAppStore />}</StoreList>
          <Technology />
        </HeaderContentWrapper>
      </SectionWrapper>
    );
  }
}

const StyledCompanyTitle = styled(CompanyTitle)``;

const HeaderContentWrapper = styled.div`
  max-width: 400px;

  @media screen and (max-width: 768px) {
    text-align: center;
    margin: 0 auto;
  }

  & > * {
    margin: 24px 0;
  }
`;

const StoreList = styled.div`
  margin: 8px 0;
  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const StyledAppStore = styled(AppStore)`
  width: 100px;
`;

export const SectionWrapper = styled(Section)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 56px 0;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

// ${RatioImage} {
//   width: 100%;
//   padding-top: 55%;
// }

const Title = styled.div`
  font-size: 32px;
  color: #212529;
  font-weight: bold;
  margin-bottom: 8px;
`;

const ProductShortDescription = styled.div`
  color: #6c757d;
  font-size: 16px;
  line-height: 32px;
`;

const GoToWebsiteButton = styled(Button)`
  margin: 8px 0;
  padding: 10px 18px;
`;
